import $ from 'jquery';
require('./vendor/custom-scrollbar/enscroll-0.6.2.min.js');

// $('.md-search-results__sidebar__main').enscroll({
//       verticalTrackClass: 'track',
//       verticalHandleClass: 'handle',
//       drawScrollButtons: true,
//       scrollUpButtonClass: 'scroll-up',
//       scrollDownButtonClass: 'scroll-down',
//      addPaddingToPane: false
//   });


// WEBPACK FOOTER //
// ./lib/assets/js/scrollbar.js